import { GenericError } from '@psyomics/ui-components';
import { useQuery } from 'urql';

import { GetSelfReferralServiceDocument, GetSelfReferralServiceQuery } from './generated/self-referral';
import { SelfReferralRegister } from './self-referral-register';

const SelfReferral = ({ selfReferralCode }: { readonly selfReferralCode: string }) => {
  const [{ data }] = useQuery<GetSelfReferralServiceQuery>({
    query: GetSelfReferralServiceDocument,
    variables: {
      input: { selfReferralCode },
    },
  });
  const result = data?.getSelfReferralService ?? undefined;
  if (!result?.organisation.code || !result.service.code) return <GenericError />;

  return <SelfReferralRegister redirect={`/self-referral/init/${selfReferralCode}`} />;
};

export { SelfReferral };
